export default {"src":"/_next/static/media/Logomark (2).30a46fe5.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};